// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"96":"43603d7315ebf01488ae","922":"271e8aab61ba54993c9f"}[chunkId] + ".js";
};